import PropTypes from 'prop-types';
import { photo } from '../../../common/shapes';

export const chairRentalPaymentShape = PropTypes.shape({
  id: PropTypes.string,
  amount: PropTypes.number,
  brand: PropTypes.string,
  funding: PropTypes.string,
  last4: PropTypes.string,
  currency: PropTypes.string,
  expiration: PropTypes.string,
  fromDate: PropTypes.string,
  toDate: PropTypes.string,
  status: PropTypes.string,
  boothRentalId: PropTypes.string,
  markedAsPaid: PropTypes.bool,
  chargedAt: PropTypes.string,
  refundedAt: PropTypes.string,
  error: PropTypes.string,
});

export const chairRentalShape = PropTypes.shape({
  id: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  barberId: PropTypes.string.isRequired,
  barber: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    photos: PropTypes.arrayOf(photo),
  }).isRequired,
  payoutPeriodInDays: PropTypes.number,
  paymentDay: PropTypes.number,
  paymentAmount: PropTypes.number,
  overdueAmount: PropTypes.number,
  totalDueAmount: PropTypes.number,
  nextPaymentAmount: PropTypes.number,
  nextPayment: chairRentalPaymentShape,
  overduePayments: PropTypes.arrayOf(chairRentalPaymentShape),
  dueDate: PropTypes.string,
});
